<template>
  <slide-y-up-transition :duration="400+(index*100)" :delay="200+(index*100)">
    <div v-show="show" class="box-info" v-html="item"></div>
  </slide-y-up-transition>
</template>

<script>
export default {
  name: 'ItemBoxInfo',
  props: ['index', 'item'],
  data() {
    return {
      show: false
    }
  },
  mounted() {
    this.show = true;
  }
}
</script>